<!-- <app-common-header *ngIf="isHeaderVisible"></app-common-header> -->
<!-- <div class="body"> -->
<app-common-side-navbar></app-common-side-navbar>
<!-- ** For testing purposes (To confirm whether other elements are not affected) -->
<!-- <router-outlet *ngIf="!isFooterVisible"></router-outlet> -->
<notifier-container></notifier-container>
<div id="watermark">Ravi's Academy {{ userName }}</div>

<!-- </div> -->
<!-- <app-footer *ngIf="isFooterVisible"></app-footer> -->
